import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { 
  getAllGodowns, 
  getGodown, 
  createGodown, 
  updateGodown, 
  deleteGodown,
  getAvailableGodowns,
} from "services/godown";

export const useAllGodowns = (filters) => {
  return useQuery({
    queryKey: ["godowns", filters],
    queryFn: () => getAllGodowns(filters),
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
};

export const useAvailableGodowns = (filters, options = {}) => {
  return useQuery({
    queryKey: ["available-godowns", filters],
    queryFn: () => getAvailableGodowns(filters),
    staleTime: 1000 * 60 * 5,
    ...options,
  });
};

export const useGodown = (id) => {
  return useQuery({
    queryKey: ["godown", id],
    queryFn: () => getGodown(id),
    enabled: !!id,
    staleTime: 1000 * 60 * 5,
  });
};

export const useCreateGodown = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data) => createGodown(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["godowns"] });
    },
  });
};

export const useUpdateGodown = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, data }) => updateGodown(data, id),
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({ queryKey: ["godowns"] });
      queryClient.invalidateQueries({ queryKey: ["godown", variables.id] });
    },
  });
};

export const useDeleteGodown = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id) => deleteGodown(id),
    onSuccess: (data, id) => {
      queryClient.invalidateQueries({ queryKey: ["godowns"] });
      queryClient.invalidateQueries({ queryKey: ["godown", id] });
    },
  });
};

